export default "__VITE_ASSET__DH4mU7ov__"